export const MapMode = {
  inspect: 'inspect',
  measure: 'measure',
  draw_trench: 'draw_trench',
  streetsmart: 'streetsmart',
  draw_excavation_incident: 'draw_excavation_incident',
  draw_positional_deviation: 'draw_positional_deviation',
  draw_work_instruction: 'draw_work_instruction',
  draw_annotation: 'draw_annotation',
  draw_risk: 'draw_risk',
} as const;

export type MapMode = (typeof MapMode)[keyof typeof MapMode];

export interface MaintenanceLayers {
  eisVoorzorgsmaatregel: boolean;
  klicMeldingenInProject: boolean;
  extraDetailInfo: boolean;
  annotations: boolean;
  maatvoeringen: boolean;
  dieptes: boolean;
  designLayers: Record<string, boolean>;
  risk: boolean;
  veiligGraven: boolean;
  risicoInventarisatie: boolean;
}

export interface MapStateModel {
  mapMode: MapMode;
  center: number[];
  zoom: number;
  showGPSLocation: boolean;
  followGPSLocation: boolean;
  geolocationPermission: 'granted' | 'denied' | 'prompt' | 'unknown';
  layers: {
    basemaps: string[];
    klicLayerFilter: string[];
    maintenanceLayers: MaintenanceLayers;
    isDefault: boolean;
  };
}
export class SetMapMode {
  static readonly type = '[Map] Set Map Mode';
  constructor(public payload: { mapMode: MapMode }) {}
}

export class SetCenterAndZoom {
  static readonly type = '[Map] Set Center And Zoom';
  constructor(public payload: { center: number[]; zoom: number }) {}
}

export class ResetCenterAndZoom {
  static readonly type = '[Map] Reset Center And Zoom';
  constructor() {}
}

export class UpdateLayers {
  static readonly type = '[Map] UpdateLayers';
  constructor(
    public payload: { basemaps?: string[]; klicLayerFilter?: string[]; maintenanceLayers?: Partial<MaintenanceLayers> }
  ) {}
}

export class EnableGpsWatch {
  static readonly type = '[Map] EnableGpsWatch';
  constructor(public payload: { followGPSLocation: boolean }) {}
}

export class DisableGPSWatch {
  static readonly type = '[Map] DisableGPSWatch';
  constructor() {}
}

export class DisableGPSFollow {
  static readonly type = '[Map] DisableGPSFollow';
  constructor() {}
}

export class ResetMapState {
  static readonly type = '[Map] Reset Map State';
  constructor() {}
}

export class SetGeolocationPermission {
  static readonly type = '[Map] Set Geolocation Permission';
  constructor(public payload: { status: 'granted' | 'denied' | 'prompt' | 'unknown' }) {}
}
